<template>
  <div class="totals-chart">
    <highcharts ref="chartTotals" :options="options" />
  </div>
</template>
<script>
import { Chart } from 'highcharts-vue'
import moment from 'moment'
export default {
  name: 'TotalsChartOverTime',
  components: {
    highcharts: Chart
  },
  props: {
    transactions: Object
  },
  watch: {
    transactions(newVal) {
      console.log('Updated transactions:', newVal)
      this.$nextTick(() => {
        if (this.$refs.chartTotals) {
          this.$refs.chartTotals.updateOptions(this.options)
        }
      })
    }
  },
  computed: {
    options() {
      if (!this.transactions || !this.transactions.length) {
        return { series: [] } // Return an empty series to prevent errors
      }

      const groupedData = {}
      let cumulativeTotal = 0
      const cumulativeSeries = []

      // Group transactions by date
      this.transactions.forEach(({ total, date, firmName }) => {
        const formattedDate = moment(date).format('YYYY-MM-DD')
        if (!groupedData[formattedDate]) groupedData[formattedDate] = {}
        if (!groupedData[formattedDate][firmName]) groupedData[formattedDate][firmName] = 0
        groupedData[formattedDate][firmName] += total
      })

      // Sorting categories (dates)
      const categories = Object.keys(groupedData).sort()
      // const firmNames = [...new Set(this.transactions.map((item) => item.firmName))]

      // Generating firm-wise series for stacked columns
      // const series = firmNames.map((firm) => ({
      //   name: firm,
      //   data: categories.map((date) => groupedData[date][firm] || 0),
      //   type: 'column'
      // }))
      const series = []
      // Compute cumulative total over time
      categories.forEach((date) => {
        const dailyTotal = Object.values(groupedData[date]).reduce((sum, value) => sum + value, 0)

        cumulativeTotal += dailyTotal
        cumulativeSeries.push(cumulativeTotal)
      })

      // Add cumulative total as a line series
      series.push({
        name: 'Cumulative Total',
        data: cumulativeSeries,
        type: 'line',
        color: 'black',
        marker: { enabled: true },
        lineWidth: 2
      })

      return {
        chart: { type: 'column' },
        credits: { enabled: false },
        title: { text: 'Activity Over Time' },
        xAxis: { categories, title: { text: 'Date' } },
        yAxis: {
          min: 0,
          title: { text: 'Total Activity' },
          stackLabels: { enabled: true }
        },
        legend: { reversed: true },
        plotOptions: { column: { stacking: 'normal' } },
        series
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
